// JIRA LPPLWEBMOB-563
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ComponentId } from "./enums";

export type FormInput = {
  [ComponentId.CORRECTNESS_AGREEMENT]: string;
  [ComponentId.AGREE_DECISION_EMAIL]: string;
  [ComponentId.AGREE_RENTIN_VEHICLE_EMAIL]: string;
  [ComponentId.AGREE_CONTACT_EMAIL]: string;
};

export type FormDataInputs = FormInput;

const initialState: FormInput = {
  [ComponentId.CORRECTNESS_AGREEMENT]: "",
  [ComponentId.AGREE_DECISION_EMAIL]: "",
  [ComponentId.AGREE_RENTIN_VEHICLE_EMAIL]: "",
  [ComponentId.AGREE_CONTACT_EMAIL]: "",
};

const summarySlice = createSlice({
  name: "@AC/summary",
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<FormInput>) => {
      state[ComponentId.CORRECTNESS_AGREEMENT] =
        action.payload[ComponentId.CORRECTNESS_AGREEMENT];
      state[ComponentId.AGREE_DECISION_EMAIL] =
        action.payload[ComponentId.AGREE_DECISION_EMAIL];
      state[ComponentId.AGREE_RENTIN_VEHICLE_EMAIL] =
        action.payload[ComponentId.AGREE_RENTIN_VEHICLE_EMAIL];
      state[ComponentId.AGREE_CONTACT_EMAIL] =
        action.payload[ComponentId.AGREE_CONTACT_EMAIL];
    },
    setACCorrectnessAgreement: (state, action) => {
      state[ComponentId.CORRECTNESS_AGREEMENT] = action.payload;
    },
    setACAgreeDecisionEmail: (state, action) => {
      state[ComponentId.AGREE_DECISION_EMAIL] = action.payload;
    },
    setACAgreeRentinVehicleEmail: (state, action) => {
      state[ComponentId.AGREE_RENTIN_VEHICLE_EMAIL] = action.payload;
    },
    setACAgreeContactEmail: (state, action) => {
      state[ComponentId.AGREE_CONTACT_EMAIL] = action.payload;
    },
    resetData: (state) => initialState,
  },
});

export const {
  setData: setACSummaryFormData,
  resetData: resetSummaryData,
  setACCorrectnessAgreement,
  setACAgreeContactEmail,
  setACAgreeDecisionEmail,
  setACAgreeRentinVehicleEmail,
} = summarySlice.actions;

export const { reducer } = summarySlice;
